import React from "react";
import imgnotfound from "../imgpsh_fullsize_anim.png" 

const MainPage = () => {
  return (
    <>
      <section className="section-b-space pt-120 mb-5">
        <div className="container mt-5">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="row">
                <div className="col-lg-4 text-center">
                  <img
                    src={imgnotfound} style={{height:"100%"}}
                    alt="404 image"
                  />
                </div>
                <div className="col-lg-8">
                  <h1 style={{ color: "#ce1415" }} className="mb-3">
                    Welcome to Halal Meat Store!
                  </h1>
                  <p className="mb-2" style={{ fontSize: 18 }}>
                    Your one-stop destination for the freshest and finest
                    quality halal meats. <strong>We take pride in delivering premium
                    cuts, sourced with care and prepared to perfection.</strong>
                  </p>
                  <p className="mb-2" style={{ fontSize: 18 }}>
                    Click the button below to explore our wide range of products
                    and experience the taste of quality and tradition.
                  </p>
                  <a
                    href="https://meatwala.co.uk"
                    target="_blank"
                    className="btn btn-primary mt-3"
                    style={{
                      background: "#ce1415",
                      border: "#ce1415",
                    }}
                  >
                    <i className="fa fa-home me-2" />
                    Explore Us
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MainPage;
